import {getCsrfToken} from "../../../../plugins/get-csrf-token";
import {swalConfirmFire, swalErrorFire, swalFire} from "../../../../plugins/sweet-alert/sweet-alert-default";
import {attachDataTables} from "../../../../plugins/datatables";
import Swal from "sweetalert2";

export default function reportScripts($page) {
    getReport(true);

    $('#reportTypeButtons input[type=radio]').on('change', uncheckNotGroupedStatementsBeforeGetReport);
    $('#reportLSSButton').on('change', uncheckNotGroupedStatementsBeforeGetReport);
    $('#reportStatementsButton').on('change', uncheckNotGroupedStatementsBeforeGetReport);
    $('#reportHiAnswersButtons input[type=radio]').on('change', uncheckNotGroupedStatementsBeforeGetReport);
    $('#reportGroupStatements').on('click', function() {
        swalConfirmFire({
            title: 'Please enter name for statements group',
            input: 'text',
            showCancelButton: false,
            inputValidator: (value) => {
                if (!value) {
                    return 'You need to write something!'
                }
            }
        }).then(groupName => {
            window.groupName = groupName.value;
            getReport();
        });
    });
    $($page)
        .on('change', '#report .revert-button input[type=checkbox]', uncheckNotGroupedStatementsBeforeGetReport)
        .on('change', '#report .set-hide-button input[type=checkbox]', function () {
            $(this).closest('tr.statement').addClass('hide');
            $(this).closest('.table').find('.hide-statement-icon').removeClass('hide');
        })
        .on('click', '.hide-statement-icon', function() {
            $(this).closest('table').find('tr.statement.hide .set-hide-button input:checkbox').prop('checked', false);
            $(this).closest('table').find('tr.statement').removeClass('hide');
            $(this).addClass('hide');
        })
        .on('click', '#report .ungroup-button', function () {
            $(this).find('input').prop("checked", false);
            uncheckNotGroupedStatementsBeforeGetReport();
        })
        .on('click', '[data-edit-group-name]', toggleEditGroupNameMode)
        .on('click', '[data-cancel-group-name]', toggleEditGroupNameMode)
        .on('click', '[data-save-group-name]', () => getReport())
        .on('click', "#reportShowLegend", function () {
            let legendFor = $('#reportHiAnswersButtons input[type=radio]:checked').val();

            if (legendFor === 'new_icode') $page.find('.report-legend-for-new-icode').slideToggle();
            if (legendFor === 'ptc_icode') $page.find('.report-legend-for-ptc-icode').slideToggle();
            if (legendFor === 'show') $page.find('.report-legend-for-classic-icode').slideToggle();
        })
        .on('click', "#reportLegendClose", function () {
            $page
                .find('.report-legend-for-new-icode, .report-legend-for-ptc-icode, .report-legend-for-classic-icode')
                .slideUp();
        });
    $(".showVersionListModal").on('click', showVersionListModal);
    $(".saveVersion").on('click', saveVersion);
    $(".copyToClipboard").on('click', copyReportLinkUrlToClipboard);
}

function copyReportLinkUrlToClipboard(event) {
    const $button = $(event.currentTarget);
    navigator.clipboard
        .writeText($button.data('copy-to-clipboard'))
        .then(() => $button.find('i')
            .removeClass('bx-copy-alt')
            .addClass('bx-check')
        );
}

function uncheckNotGroupedStatementsBeforeGetReport() {
    $(document)
        .find('.report-legend-for-new-icode, .report-legend-for-ptc-icode, .report-legend-for-classic-icode')
        .slideUp();
    uncheckNotGroupedStatements();
    getReport();
}

function attachReportScripts() {
    $(document).find('[data-toggle="tooltip"]').tooltip();
}

function getReport(getSettingsFromVersion = false) {
    const $report = $('#report');
    const getReportUrl = $report.data('get-report-url');
    const reportSettings = getReportSettings();

    if (getSettingsFromVersion) {
        reportSettings.getSettingsFromVersion = true;
    }

    $.ajax({
        type: "POST",
        headers: {'X-CSRF-TOKEN': getCsrfToken()},
        url: getReportUrl,
        data: reportSettings,
        beforeSend: showLoader,
        success: function (response) {
            $report.html(response);
            attachReportScripts();
        },
        error: getReportError,
        complete: hideLoader,
    });
}

function getReportError() {
    swalErrorFire({
        title: 'Report error',
        text: 'The system encountered error in loading the report data. ' +
            'Please try again later, or contact with support.',
    });
}

function showLoader() {
    const ajaxLoaderHtml = '' +
        '<div class="reportAjaxLoader">' +
        '<em class="bx bx-spin bx-loader-alt"></em>' +
        '<p>Please wait for loading report data.</p>' +
        '</div>';
    $('#report').html(ajaxLoaderHtml);
}

function hideLoader() {
    $('.reportAjaxLoader').remove();
}

function getReportSettings() {
    return {
        type: $('#reportTypeButtons input[type=radio]:checked').val(),
        showStatements: $('#reportStatementsButton').is(':checked'),
        showLSS: $('#reportLSSButton').is(':checked'),
        hiAnswer: $('#reportHiAnswersButtons input[type=radio]:checked').val(),
        reversed: getAllReversedStatements(),
        grouped: getAllGroupedStatements(),
        versionId: getVersionId(),
        hidden: getAllHiddenStatements(),
    };
}

function getVersionId() {
    return $('#reportVersionId').val();
}

function uncheckNotGroupedStatements() {
    $('#report').find('.objectStatementsGroup')
        .find(".statementGroupedNew input[type=checkbox]:checked")
        .prop("checked", false);
}

function getAllGroupedStatements() {
    const objectStatementsGroups = $('#report').find('.objectStatementsGroup');
    let grouped = [];
    objectStatementsGroups.each(function (index, objectStatementsGroup) {
        const statementCodesCheckedForGroup = $(objectStatementsGroup).find(".statementGroupedNew input[type=checkbox]:checked")
            .map(function(){return $(this).data('code');})
            .get();
        if (statementCodesCheckedForGroup.length > 1) {
            grouped.push({
                'name': window.groupName,
                'codes': statementCodesCheckedForGroup,
            });
            window.groupName = null;
        }
        const statementsGroupedBefore = $(objectStatementsGroup).find(".statementGrouped");
        statementsGroupedBefore.each(function (index, statementGroupedBefore) {
            const statementCodesCheckedForGroup = $(statementGroupedBefore).find("input[type=checkbox]:checked")
                .map(function(){return $(this).data('code');})
                .get();
            if (statementCodesCheckedForGroup.length > 1) {
                grouped.push({
                    'name': $(statementGroupedBefore).closest('tr.statement').find('.edit-group-name input').val(),
                    'codes': statementCodesCheckedForGroup,
                });
            }
        });
    });

    return grouped;
}

function getAllReversedStatements() {
    return $('#report')
        .find(".revert-button input[type=checkbox]:checked, .statementRevertedInGroup:checked")
        .map(function(){
            return $(this).data('code');
        })
        .get();
}

function getAllHiddenStatements() {
    return $('#report')
        .find(".set-hide-button input[type=checkbox]:checked")
        .map(function(){
            return $(this).data('code');
        })
        .get();
}

function toggleEditGroupNameMode(event) {
    $(event.currentTarget)
        .closest('.statement-name')
        .find('.edit-group-name, .group-name, [data-edit-group-name], [data-save-group-name], [data-cancel-group-name]')
        .toggleClass('hide');
}

function showVersionListModal(event) {
    event.preventDefault();
    const versionListUrl = $(event.currentTarget).data('url');
    const $modal = $('#version-list-modal');

    $modal
        .modal('show')
        .find('.modal-content')
        .load(versionListUrl, function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }

            attachDataTables($modal);
        });
}

function saveVersion(event)
{
    uncheckNotGroupedStatements();
    const saveVersionUrl = $(event.currentTarget).data('url');
    const settings = getReportSettings();
    const publicSettings = {
        name: $('#versionSettings\\.name').val(),
        publicShowTotal: $('#versionSettings\\.showTotal').is(':checked'),
        publicShowGenderFilter: $('#versionSettings\\.showGenderFilter').is(':checked'),
        publicShowAgeFilter: $('#versionSettings\\.showAgeFilter').is(':checked'),
        publicShowStatements: $('#versionSettings\\.showStatements').is(':checked'),
        publicShowLSS: $('#versionSettings\\.showLSS').is(':checked'),
        publicShowHiAnswer: $('#versionSettings\\.showHiAnswer').is(':checked'),
    };

    $.ajax({
        type: "PUT",
        headers: {'X-CSRF-TOKEN': getCsrfToken()},
        url: saveVersionUrl,
        data: Object.assign(settings, publicSettings),
        success: function () {
            swalFire({
                title: 'Report version',
                text: 'The report version data has beed saved.',
                icon: 'success',
            });
        },
        error: function () {
            swalErrorFire({
                title: 'Report version error',
                text: 'The system encountered error in saving the report version data. ' +
                    'Please try again later, or contact with support.',
            });
        },
    });
}
